import { render, staticRenderFns } from "./bauma2022.vue?vue&type=template&id=5b0634b6&"
import script from "./bauma2022.vue?vue&type=script&lang=js&"
export * from "./bauma2022.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports